import { EditCategoryWidget } from '@modules/common/components/EditCategoryWidget';
import { TRACKED_KEYWORD } from '@modules/common/constants';
import { Category } from '@modules/common/types';
import { AddPhrase } from '@modules/feedback/components/AddPredictions/AddPhrase';
import { Stack, TextField, Typography } from '@mui/material';
import { UUID } from 'v2/core/entities/uuid';

interface AddNewTrackedKeywordFormProps {
  feedbackID: UUID;
  phraseList: string[];
  setPhraseList: React.Dispatch<React.SetStateAction<string[]>>;
  trackedKeywordName: string;
  setTrackedKeywordName: (trackedKeywordName: string) => void;
  selectedCategory: Category | undefined;
  setSelectedCategory: (selectedCategory: Category) => void;
}

export const AddNewTrackedKeywordForm = ({
  feedbackID,
  phraseList,
  setPhraseList,
  trackedKeywordName,
  setTrackedKeywordName,
  selectedCategory,
  setSelectedCategory,
}: AddNewTrackedKeywordFormProps) => {
  return (
    <Stack spacing={4}>
      <Stack spacing={1}>
        <Stack component="label" htmlFor="trackedKeywordName" spacing={0.5}>
          {TRACKED_KEYWORD} Name
        </Stack>
        <TextField
          type="text"
          name="trackedKeywordName"
          required
          placeholder={`${TRACKED_KEYWORD} name`}
          fullWidth
          variant="outlined"
          autoFocus
          value={trackedKeywordName}
          onChange={({ target: { value } }) =>
            setTrackedKeywordName(value.trim())
          }
        />
      </Stack>
      <Stack spacing={1}>
        <Typography>Category to tag this record with</Typography>
        <EditCategoryWidget
          selectedCategory={selectedCategory}
          updateSelectedCategory={setSelectedCategory}
        />
      </Stack>
      <AddPhrase
        feedbackID={feedbackID}
        phraseList={phraseList}
        setPhraseList={setPhraseList}
      />
    </Stack>
  );
};
